import { Trans, useTranslation } from 'react-i18next';
import Link from '../../../../shared/library/Link';
import PaymentJourneyMessage from '../../../../shared/components/PaymentJourneyMessage';
import BookingButton from '../../../../shared/components/BookingButton';

interface OrderNotFoundMessageProps {
  emailAddress?: string;
}

export default function OrderNotFoundMessage(props: OrderNotFoundMessageProps) {
  const { emailAddress = 'conferencecustomerservices@informa.com' } = props;
  const { t } = useTranslation();

  return (
    <PaymentJourneyMessage
      title={t('site.pricing.order-not-found')}
      description={
        <Trans
          i18nKey="site.pricing.order-not-found.instructions"
          values={{ email: emailAddress }}
        >
          <Link href={`mailto:${emailAddress}`} target="blank">
            {emailAddress}
          </Link>
        </Trans>
      }
      button={<BookingButton size="small" />}
    />
  );
}
